import * as Sentry from "@sentry/browser";
import React from "react";
import { Col, Grid, Row } from "react-bootstrap";
import LogoLink from "./LogoLink";

interface BoundaryState {
  hasError: boolean;
  eventId?: string;
  error?: string;
}

export default class ErrorBoundary extends React.Component<{}, BoundaryState> {
  state: BoundaryState = {
    hasError: false,
    error: undefined,
    eventId: undefined
  };

  static getDerivedStateFromError(e: Error) {
    return { hasError: true, error: e.message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });

    /* Leaving this turned off for now */
    // Sentry.showReportDialog({
    //   eventId: this.state.eventId,
    //   subtitle: 'Our team has been notified.<br><br> If you would like to help us improve, use the form below to tell us what happened.  If this problem persists, feel free to contact us at info@acp-usa.org or 212-752-0700 for assistance.',
    //   subtitle2: '',
    //   successMessage: 'Thank you for your feedback.\n\nPlease reload the page and try again.'
    // });
  }

  public render = () => {
    if (!this.state.hasError) return this.props.children;

    // error template:
    return (
      <Grid
        style={{
          background: "white",
          maxWidth: "730px",
          border: "1px solid #666",
          padding: "0 15px 14px 15px"
        }}
      >
        <Row style={{ paddingBottom: "1em", background: "#fff" }}>
          <Col xs={12}>
            <h2 className="pull-left">Oh No!</h2>
            <LogoLink />
          </Col>

          <Col xs={12} style={{ marginTop: "10px" }}>
            <p>An unexpected error has occurred. We have been notified.</p>
            <p>Please reload the page to try again.</p>
            <p>
              If this error persists, you can contact us at{" "}
              <a href="mailto:info@acp-usa.org">info@acp-usa.org</a> or
              212-752-0700 for assistance.
            </p>
          </Col>
        </Row>
      </Grid>
    );
  };
}
